import { FC } from 'react';
import MuiMenu from '@mui/material/Menu';
import { IMenuProps } from './types';

export const Menu: FC<IMenuProps> = props => <MuiMenu {...props} />;
